import React from 'react';

function SaveIcon(props) {
  return (
    <svg
    width={41}
    height={40}
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.0848 22.7278L14.6992 26.8606V11.8745H26.0792V26.8606L20.6936 22.7278L20.3892 22.4943L20.0848 22.7278Z"
      stroke="#474747"
    />
    <path
      d="M20.5972 16.6816H22.8101V17.4229H20.5972V19.7109H19.8506V17.4229H17.6484V16.6816H19.8506V14.3828H20.5972V16.6816Z"
      fill="#5C5C5C"
    />
  </svg>
  );
}

export default SaveIcon;
